import { CREDENTIAL_ICON_PATHS } from '../lib/credential-icons';

export interface ServiceIconProps {
  slug: string;
  label: string;
  brandColor: string;
  size?: number;
  className?: string;
}

/**
 * Renders a brand SVG logo inside a colored circle when a Simple Icons entry exists,
 * otherwise falls back to a bold initial letter.
 */
export function ServiceIcon({ slug, label, brandColor, size = 32, className = '' }: ServiceIconProps) {
  const icon = CREDENTIAL_ICON_PATHS[slug];
  const fontSize = size <= 28 ? 'text-[10px]' : 'text-sd-xs';

  return (
    <div
      className={`rounded-sd-full flex items-center justify-center shrink-0 font-bold text-white ${className}`}
      style={{ backgroundColor: brandColor, width: size, height: size }}
      aria-hidden="true"
    >
      {icon ? (
        <svg
          viewBox="0 0 24 24"
          fill="white"
          style={{ width: size * 0.55, height: size * 0.55 }}
          role="img"
          aria-label={label}
        >
          <path d={icon.path} />
        </svg>
      ) : (
        <span className={fontSize}>{label.charAt(0).toUpperCase()}</span>
      )}
    </div>
  );
}
